import React from "react";
import { useAuth } from "@/context/AuthContext";
import { PauseCircle, Clock, LogOut } from "lucide-react";

export default function BlockedOrg({ reason }) {
  const { user, logout } = useAuth();
  const suspended = reason === "suspended";
  const Icon = suspended ? PauseCircle : Clock;
  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-slate-50 p-6" data-testid="org-blocked-state">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm">
        <div className={`mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full ${suspended ? "bg-rose-50" : "bg-amber-50"}`}>
          <Icon className={`h-7 w-7 ${suspended ? "text-rose-500" : "text-amber-500"}`} />
        </div>
        <h1 className="text-xl font-bold text-slate-900" data-testid="org-blocked-title">
          {suspended ? "Organisation suspendue" : "Période d'essai expirée"}
        </h1>
        <p className="mt-2 text-sm text-slate-500">
          {suspended
            ? "L'accès à votre organisation a été suspendu. Contactez l'équipe ActiPilote pour le rétablir."
            : "Votre période d'essai est terminée. Activez un abonnement avec l'équipe ActiPilote pour continuer."}
        </p>
        {user?.email && <p className="mt-3 text-xs text-slate-400">Connecté en tant que {user.email}</p>}
        <button
          onClick={logout}
          data-testid="org-blocked-logout"
          className="mt-6 inline-flex w-full items-center justify-center gap-2 rounded-lg bg-slate-900 px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-slate-800"
        >
          <LogOut className="h-4 w-4" /> Se déconnecter
        </button>
      </div>
    </div>
  );
}
